var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables17 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "731.672px",
    height: "731.083px",
    viewBox: "0 0 731.672 731.083",
    enableBackground: "new 0 0 731.672 731.083",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.627,161.637c115.671,44.284,187.2,122.448,223.052,228.071 c-17.262,16.594-34.219,32.57-50.829,47.871c-74.523-32.088-116.753-38.188-122.981-25.76 c-5.562,11.082,17.413,36.846,71.451,72.073c-42.419,37.184-82.526,69.856-120.093,98.254 c-64.334-26.041-100.878-30.397-106.629-18.908c-4.815,9.617,11.875,30.312,51.759,58.671 C153.618,726.627,51.583,752.24,14.996,714.822c-25.392-25.98-19.231-82.376,23.792-163.76 c26.576,40.358,46.412,57.577,56.159,53.155c12.241-5.561,8.392-45.49-18.333-116.64c32.412-49.396,75.588-105.425,130.205-167.296 c30.224,48.563,52.854,69.447,63.479,64.62c12.134-5.518,8.486-44.844-17.691-114.984 C284.918,235.374,320.531,199.246,359.627,161.637L359.627,161.637z M535.064,0l-78.147,161.011 c32.487,18.741,60.346,41.004,83.965,66.546l122.582-98.898l-37.441-46.37l-66.896,53.97L608.054,35.44L535.064,0L535.064,0z  M593.591,302.66l138.081-69.865l-36.649-72.407l-147.457,74.621C565.488,255.572,580.777,278.161,593.591,302.66z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables17, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-17.38077a34.svg";
export { ForwardRef as ReactComponent };